/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Categories_Delete_ConfirmInputs */

const en_admin_categories_delete_confirm = /** @type {(inputs: Admin_Categories_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Are you sure you want to delete this category?`)
};

const zh_admin_categories_delete_confirm = /** @type {(inputs: Admin_Categories_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`确定要删除此分类吗？`)
};

/**
* | output |
* | --- |
* | "Are you sure you want to delete this category?" |
*
* @param {Admin_Categories_Delete_ConfirmInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_categories_delete_confirm = /** @type {((inputs?: Admin_Categories_Delete_ConfirmInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Categories_Delete_ConfirmInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_categories_delete_confirm(inputs)
	return zh_admin_categories_delete_confirm(inputs)
});
export { admin_categories_delete_confirm as "admin.categories.delete_confirm" }